'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasEmailCapturePromptFromCurrentSession = undefined;

var _isEmailCapturePromptMessage = require('../../pubnub-message/operators/isEmailCapturePromptMessage');

var _getMessageIsApproximatelyFromCurrentSession = require('../../pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('./hasMessages');

var _getMessages = require('./getMessages');

var hasEmailCapturePromptFromCurrentSession = exports.hasEmailCapturePromptFromCurrentSession = function hasEmailCapturePromptFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastEmailCaptureMessage = messages.findLast(_isEmailCapturePromptMessage.isEmailCapturePromptMessage);

  return !!(lastEmailCaptureMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastEmailCaptureMessage));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasEmailCapturePromptFromCurrentSession.js
// module id = 753
// module chunks = 2 3